import React from 'react';
import { FaGraduationCap, FaUniversity, FaUsers, FaChartLine, FaQuoteLeft } from 'react-icons/fa';
import './AboutJourney.css';

const AboutJourney = () => {
  const journeySteps = [
    {
      year: "2021",
      title: "The Seed is Sown",
      description: "Established with a vision to provide accessible higher education to rural students, bridging the gap between village life and academic excellence.",
      icon: <FaUniversity />,
    },
    {
      year: "2022",
      title: "Building Excellence",
      description: "Successfully introduced the Arts streams, gaining university accreditation and establishing our premier NCC wing.",
      icon: <FaGraduationCap />,
    },
    {
      year: "2023",
      title: "Infrastructure Growth",
      description: "Inaugurated our massive digital library and state-of-the-art laboratories, creating a world-class environment for our students.",
      icon: <FaChartLine />,
    },
    {
      year: "2024",
      title: "Modern Legacy",
      description: "Today, we stand as a beacon of progress with 150+ government selections and a thriving community of responsible citizens.",
      icon: <FaUsers />,
    }
  ];

  return (
    <div className="oj-journey-section">
      <div className="oj-container">
        {/* Header Section */}
        <div className="oj-header">
          <div className="oj-tag">Our History</div>
          <h2 className="oj-title">The Story of <span>SK College</span></h2>
          <p className="oj-subtitle">
            A decade of dedication, a lifetime of impact. Follow our timeline from a humble dream to a landmark institution.
          </p>
        </div>

        {/* Timeline Grid */}
        <div className="oj-timeline-wrapper">
          {journeySteps.map((step, index) => (
            <div key={index} className={`oj-timeline-row ${index % 2 !== 0 ? 'oj-row-reverse' : ''}`}>
              
              {/* Image/Icon Side */}
              <div className="oj-visual-side">
                <div className="oj-icon-circle">
                  {step.icon}
                  <div className="oj-year-bubble">{step.year}</div>
                </div>
              </div>

              {/* Text side */}
              <div className="oj-content-side">
                <div className="oj-card">
                  <FaQuoteLeft className="oj-quote-icon" />
                  <h3 className="oj-card-title">{step.title}</h3>
                  <p className="oj-card-text">{step.description}</p>
                  <div className="oj-card-line"></div>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutJourney;